"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prod = exports.dev = void 0;
exports.dev = {
    production: false,
    url: /*"http://localhost:8000/circleloop"*/ "https://dev-api.kumodi.com/circleloop",
    lsUrl: "https://dev-ls.kumodi.com",
    websocket: "wss://dev-ls.kumodi.com",
    version: "0.0.4",
    name: "CircleLoop",
    helpAndFeedback: true,
};
exports.prod = {
    production: true,
    url: "https://api.kumodi.com/circleloop",
    lsUrl: "https://ls.kumodi.com",
    websocket: "wss://ls.kumodi.com",
    version: "0.0.4",
    name: "CircleLoop"
};
